import { lazy } from 'react';
import { Navigate, Route, useLocation } from 'react-router-dom';
import { RouteMap } from '@common/constants/RouteMap';

//#region ACP
const ACPSignUp = lazy(() => import('@admission/pages/ACP/SignUp'));
const ACPSignIn = lazy(() => import('@admission/pages/ACP/SignIn'));

const ACPResetPassword = lazy(() => import('@admission/pages/ACP/ResetPassword'));

const ACPInvalidSignUpKBA = lazy(() => import('@admission/pages/ACP/Error/InvalidSignUpKBA'));
const ACPBlockedSignUpKBA = lazy(() => import('@admission/pages/ACP/Error/BlockedSignUpKBA'));
const ACPBlockedSignUpLGPD = lazy(() => import('@admission/pages/ACP/Error/BlockedSignUpLGPD'));
const ACPBlockedSignIn = lazy(() => import('@admission/pages/ACP/Error/BlockedSignIn'));

const ACPRecoveryPassword = lazy(() => import('@admission/pages/ACP/RecoveryPassword'));

const ACPValidateConflictingEmail = lazy(() => import('@admission/pages/ACP/ValidateConflictingEmail'));
const ACPSignInUnifyPassword = lazy(() => import('@admission/pages/ACP/SignInUnifyPassword'));

const ACPInvalidRecoveryPasswordKBA = lazy(() => import('@admission/pages/ACP/Error/InvalidRecoveryPasswordKBA'));
const ACPBlockedRecoveryPasswordKBA = lazy(() => import('@admission/pages/ACP/Error/BlockedRecoveryPasswordKBA'));
const ACPChangeEmail = lazy(() => import('@admission/pages/ACP/UpdateEmail'));
const ACPChangePhone = lazy(() => import('@admission/pages/ACP/UpdatePhone'));
const ACPChangeSocialName = lazy(() => import('@admission/pages/ACP/UpdateSocialName'));
const ACPChangeContactSuccess = lazy(() => import('@admission/pages/ACP/Success/UpdateContactSuccess'));
const ACPChangePassword = lazy(() => import('@admission/pages/ACP/UpdatePassword'));
const ACPChangePasswordSuccess = lazy(() => import('@admission/pages/ACP/Success/UpdatePasswordSuccess'));

const ACPSignUpPartnerPartial = lazy(() => import('@admission/pages/ACP/SignUpPartnerPartial'));
const ACPSignUpPartnerCompleted = lazy(() => import('@admission/pages/ACP/SignUpPartnerCompleted'));

const ACPSignUpNCADCompleted = lazy(() => import('@admission/pages/ACP/SignUpNCADCompleted'));

const ACPHomePartner = lazy(() => import('@admission/pages/ACP/HomePartner'));

const ACPInvalidKba = lazy(() => import('@admission/pages/ACP/Error/InvalidResetPasswordKBA'));
const ACPBlockedKba = lazy(() => import('@admission/pages/ACP/Error/BlockedResetPasswordKBA'));

//#endregion ACP

//Private Routes
const UserProfile = lazy(() => import('../../admission/pages/UserProfile'));
const DeleteAccountOngoing = lazy(() => import('@libs/acp/pages/Account/DeleteAccountOngoing'));

export function useAdmissionRouter() {
  const { search } = useLocation();

  const admissionPublicPages = (
    <>
      <Route path={RouteMap.Root} index element={<Navigate to={`${RouteMap.SignIn}${search}`} />} />
      <Route path={RouteMap.SignIn} element={<ACPSignIn />} />

      <Route path={RouteMap.SignUp} element={<ACPSignUp />} />

      <Route path={RouteMap.signupACPErrorKBA} element={<ACPInvalidSignUpKBA />} />
      <Route path={RouteMap.signupACPBlockedKBA} element={<ACPBlockedSignUpKBA />} />
      <Route path={RouteMap.signupACPBlockedLGPD} element={<ACPBlockedSignUpLGPD />} />
      <Route path={RouteMap.signinACPFailedDocument} element={<ACPBlockedSignIn />} />

			<Route path={RouteMap.RedefinePasswordInvalidKBA} element={<ACPInvalidKba />} />
			<Route path={RouteMap.RedefinePasswordBlockedKBA} element={<ACPBlockedKba />} />

			<Route path={RouteMap.RedefinePassword} element={<ACPResetPassword />} />

      <Route path={RouteMap.ForgotPassword} element={<ACPRecoveryPassword />} />

      <Route path={RouteMap.recoveryPasswordACPErrorKBA} element={<ACPInvalidRecoveryPasswordKBA />} />
      <Route path={RouteMap.recoveryACPBlockedKBA} element={<ACPBlockedRecoveryPasswordKBA />} />

      <Route path={RouteMap.SignUpPartnerPartial} element={<ACPSignUpPartnerPartial />} />
      <Route path={RouteMap.SignUpPartnerCompleted} element={<ACPSignUpPartnerCompleted />} />
      <Route path={RouteMap.SignUpNCADCompleted} element={<ACPSignUpNCADCompleted />} />
    </>
  );

  const admissionPrivatePages = (
    <>
      <Route path={RouteMap.UserProfile} element={<UserProfile />} />
      <Route path={RouteMap.AccountDeletion} element={<DeleteAccountOngoing />} />
      <Route path={RouteMap.ChangePassword} element={<ACPChangePassword />} />
      <Route path={RouteMap.ChangePasswordSuccess} element={<ACPChangePasswordSuccess />} />
      <Route path={RouteMap.ChangeEmail} element={<ACPChangeEmail />} />
      <Route path={RouteMap.ChangePhone} element={<ACPChangePhone />} />
      <Route path={RouteMap.ChangeSocialName} element={<ACPChangeSocialName />} />
      <Route path={RouteMap.UpdateExpiredEmail} element={<ACPChangeEmail />} />
      <Route path={RouteMap.ValidateCoflictingEmailEmail} element={<ACPValidateConflictingEmail />} />
      <Route path={RouteMap.ChangeContactSuccess} element={<ACPChangeContactSuccess />} />
      <Route path={RouteMap.SigninUnifyPasswordACP} element={<ACPSignInUnifyPassword />} />
    </>
  );

  const partnerPrivatePages = <Route path={RouteMap.HomePartner} element={<ACPHomePartner />} />;

  return {
    admissionPublicPages,
    admissionPrivatePages,
    partnerPrivatePages,
  };
}
